import React, { useEffect, useState } from 'react';
import Recipe from '../../components/ReusableRecipe/ReusableRecipe';
import SideMenuTakeAction from '../../components/SideMenuTakeAction/SideMenuTakeAction';
import NearSpaceBg from '../../components/NearSpaceBg/NearSpaceBg';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import back from '../../assets/back.png';
import icon from '../../assets/ask-land.jpg';
import CarouselActions from '../../components/CarouselActions/CarouselActions';

const Container = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 9px;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);

  background-color: rgba(0,0,0,1);
  overflow:hidden;

  position: relative;

  @media (max-width: 768px) {
    height:350px;
  }

`;

const Wrapping = styled.div`
  display: flex;
  flex-wrap:wrap;
`;

const Lt = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction:column;
  height: auto;
  float:bottom;
  margin-left:0px;
`;

const Rt = styled.div`
  display: flex;
  height: auto;

  justify-content: center;
    width: 40%;
  z-index:0;
    @media (max-width: 768px) {
    margin-right:20px;

    justify-content:flex-start;
  }

`;


const Bg = styled.img`
 
  position: absolute;
  height:90%;
  justify-content: space-around;

    @media (max-width: 768px) {
   margin-right:0px;
  }
    
`;

const Inner01 = styled.div`
  display: flex;
  flex-direction:column;
    flex-start;
  width: 50%;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;
  position:absolute;
  z-index:1;

`;

const Tag = styled.span`
  font-size: 0.9rem;
  color: #13F9B2;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
    
    justify-content:left;

`;

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;

`;

const Navlink = styled(Link)`

    text-decoration:none;
    color:#ffffff;
  
`;


const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
    margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;
const Inline = styled.div`
    white-space:nowrap;
`;
const Impacts = styled.div`
  width:40vw;
  flex-direction:column;
  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;

const Impactwrappernolink = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;

`;
const Backico = styled.img`
  margin-left:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:20px;
  height:auto;
  margin-right:5px;
`;

const Input = styled.input`
  padding: 0.6em;
  margin-top: 10px;
  margin-right: 10px;
  color: #13F9B2;
  background: #000000;
  border:1px solid #13F9B2;
  border-radius: 9px;
  transition: all 0.2s;
  &:focus {
        outline: none;
        background-color: #044f37;
        
    }
  &:hover {
        outline: none;
        background-color: #044f37;
    }
`;
const Submitbutton = styled.button`
  padding: 0.6em 0.9em;
  width:fit-content;
  margin-top: 10px;
  margin-right:10px;
  color: #13F9B2;
  font-size: 14px;
  font-weight: 400;
  background-color: #000000;
  border:1px solid #13F9B2;
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.2s;
  &:focus {
        outline: none;     
    }
  &:hover {
        outline: none;
        background-color: #044f37;
    }
`;
const Scaleup = styled.div`
  transform: scale(1);
  @media (max-width: 768px) {
    transform: scale(1.09);
  }
`;

const Spacer = styled.div`
  margin-top:70px;
`;

const Carouselheader = styled.h2`

  font-family:roboto;
  font-size: 2rem;
  font-weight:400;
  color: #ffffff;
  margin: 0.4em 0em 0.7em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;

const TakeAction_Recipes = () =>{



const APP_ID= "24faf3ea";
const APP_KEY= "0af64becad3d5ee48ebb62dcf08ecf68";


const [recipes, setRecipes] = useState([]);
const [search, setSearch] = useState("");
const [query, setQuery] = useState('vegetarian');

useEffect(()=>{
  getRecipes();

}, [query]);

const getRecipes = async () => {
  const response = await fetch(
     `https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}`
    );
  const data = await response.json();
  setRecipes(data.hits);
  console.log(data.hits);
};

const updateSearch = e => {
  setSearch(e.target.value);

} 

const getSearch = e => {
  e.preventDefault();
  setQuery(search);
  setSearch('');
}
const getOnepot = e => {
  e.preventDefault();
  setQuery(search);
  setSearch('One Pot');
}
const getVegan = e => {
  e.preventDefault();
  setQuery(search);
  setSearch('Vegan');
}
const getVegetarian = e => {
  e.preventDefault();
  setQuery(search);
  setSearch('Vegetarian');
}
const getChickpea = e => {
  e.preventDefault();
  setQuery(search);
  setSearch('Chickpea');
}
const getSalmon = e => {
  e.preventDefault();
  setQuery(search);
  setSearch('Salmon');
}
    return(
      
        <body> 

          <SideMenuTakeAction />
          <NearSpaceBg/>
          
          
          
          <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree><Link to="/Take-Action"><Backico src= {back}/></Link><Navlink to="/Take-Action" >Take Action </Navlink>/ Recipes</Tree>       
          </Contentwrapper>        
              
              <Container>
    
               <Lt>
                 <Inner01>
                   <Tag>GET RECIPES</Tag>
                   <Inline>
                   <form onSubmit={getSearch}>
                    <Input 
                     type= "text" 
                     value= {search} 
                     onChange={updateSearch}/>
                    <Submitbutton>
                     Search
                    </Submitbutton>
                   </form>
                   </Inline>
                   <Wrapping>
                   <Submitbutton onClick={getOnepot}>
                     One Pot
                    </Submitbutton>
                   <Submitbutton onClick={getVegan}>
                     Vegan
                    </Submitbutton>
                    <Submitbutton onClick={getVegetarian}>
                     Vegetarian
                    </Submitbutton>
                    <Submitbutton onClick={getChickpea}>
                     Chickpea
                    </Submitbutton>
                    <Submitbutton onClick={getSalmon}>
                     Salmon
                    </Submitbutton>
                   </Wrapping>
                 </Inner01>
               </Lt>

               <Rt>
               <Bg src = {icon}/>
               </Rt>

             </Container>
              
              

           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>
              {recipes.map(recipe => (
                  <Impactwrapper><Recipe 
                  title={recipe.recipe.label}
                  image={recipe.recipe.image}
                  url={recipe.recipe.url}

                  /></Impactwrapper>
                ))}
              <Impactwrappernolink>  
              <Container>
    
               <Lt>
                 <Inner01>
                   <Tag>GET RECIPES</Tag>
                   <Inline>
                   <form onSubmit={getSearch}>
                    <Input 
                     type= "text" 
                     value= {search} 
                     onChange={updateSearch}/>
                    <Submitbutton>
                     Search
                    </Submitbutton>
                   </form>
                   </Inline>
                   <Wrapping>
                   <Submitbutton onClick={getOnepot}>
                     One Pot
                    </Submitbutton>
                   <Submitbutton onClick={getVegan}>
                     Vegan
                    </Submitbutton>
                    <Submitbutton onClick={getVegetarian}>
                     Vegetarian
                    </Submitbutton>
                    <Submitbutton onClick={getChickpea}>
                     Chickpea
                    </Submitbutton>
                    <Submitbutton onClick={getSalmon}>
                     Salmon
                    </Submitbutton>
                   </Wrapping>
                 </Inner01>
               </Lt>

               <Rt>
               <Bg src = {icon}/>
               </Rt>

             </Container> 
             </Impactwrappernolink>     
                    
              

             <Carouselheader><Navlink to="/Take-Action">TAKE ACTION</Navlink></Carouselheader>
              <Scaleup><CarouselActions/></Scaleup> 
              <Spacer/>
           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>
          
          
        </body>
      
      );

  
}

export default TakeAction_Recipes;